import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const ArtDirection = makeShortcode("ArtDirection");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`ArtefactIntro`}</h1>
    <PageDescription mdxType="PageDescription">
      <p>{`Nutze ArtefactIntro, um einen Überblick-Bereich eines digtialen Kunstwerkes zu geben. Das ArtefactIntro soll eine Banner darstellen.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Überblick</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Code</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Formartierung</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Feedback</AnchorLink>
    </AnchorLinks>
    <h2>{`Überblick`}</h2>
    <p>{`ArtefactIntro visualisiert ein digitales Kunstwerk, mit einem Logo, einem Textfeld und einem Button, der standardmäßig zur Webseite des Cranach Digital Archivs führt.`}</p>
    <h4>{`Wann zu verwenden`}</h4>
    <p>{`ArtefactIntro für den Intro eines einzelnes digitalen Kunstwerkes zu verwenden.`}</p>
    <h2>{`Formatierung`}</h2>
    <h3>{`Anatomy`}</h3>
    <ArtDirection mdxType="ArtDirection">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "58.333333333333336%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABCcAAAQnAEmzTo0AAABzklEQVQoz6WTW2sTQRiGZ4/VtlSwObZiJSAKgikqBrE3Cr1IBRuEInprmnZ3k1YtCBWPYBH073ilQbOXFgPRC02uRMH/EMgyj7O7qQ3YRtGFd2d35uWZd3e+T3S7XXq9gKFX7zPIH0MtQRAQsoSU8P3rF9bXPFzXw/MG5VJernKvVmTDK6nneG7QU61WqVQqdDqdCCzCW3P7DUKIPWWP6KSTkyTTCQzb3tdXr9f7wO4nWv4Wo2MT6LqOaZpYSkKzlAR3vOu8WC7xfOMW3uYmmtAiz47s/ia+7+8kDGhtv8K2tGhB0+Idxw4IrswJbtxc4KVb5FltCefu2m/JwhDh2Gg0dj+51fQVMDZofaNpCE7lBKfzOUrzF1i4XKBQmP1L4Ie3v4C70Djx/KXzlK4tsbh4ldl8/t+AoQ6NC1KHNRKJSbKZNKlUkkwmpf6v8Wfgx+Y7Rg+aatHAstSBCJPiRZ25M+NkskfJTs8wfSRHduoY1sgEhqEPOxRk8/1rqSb31dkThjx30pIzKSGPT+3tUWUjQ1ZU2N9UYdeqDqurDo4Ty3Xj93B8+nCdJw9u8+i+y9Zjh8rKoE8Vf7lMu92OE6p2kar1Ivr/SLWeDFk/AQQVD56B+CMBAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "ArtefactIntro anatomy",
          "title": "ArtefactIntro anatomy",
          "src": "/static/2249e68714bc3bdc8224d64deb6861db/3cbba/artefactIntro-anatomy.png",
          "srcSet": ["/static/2249e68714bc3bdc8224d64deb6861db/7fc1e/artefactIntro-anatomy.png 288w", "/static/2249e68714bc3bdc8224d64deb6861db/a5df1/artefactIntro-anatomy.png 576w", "/static/2249e68714bc3bdc8224d64deb6861db/3cbba/artefactIntro-anatomy.png 1152w", "/static/2249e68714bc3bdc8224d64deb6861db/5bc80/artefactIntro-anatomy.png 1442w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </ArtDirection>
    <p>{`Dieser Organismus besteht auch Atome und Moleküle bildet einen Intro-Bereich ab.`}</p>
    <p>{`The modal is composed of three distinct zones: A header, the body, and a footer.
Components (eg. data table, form, progress indicator) can occupy the full width
of the modal.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Container`}</strong>{`: Container in schwarzer Hintergrundfarbe. Zentriert alle Inhalte`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Logo`}</strong>{`: Enthält ein `}<a parentName="p" {...{
            "href": "../../atoms/Logo"
          }}>{`Logo (Atom)`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`ArtefactCard`}</strong>{`: Enthält das Molekül `}<a parentName="p" {...{
            "href": "../../molecules/artefactCard"
          }}>{`ArtefactCard (Molecule)`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Paragraph`}</strong>{`: Ein Paragraphtext für eine detailierte Erläuterung dieses Intros`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Button`}</strong>{`: Enthält eine `}<a parentName="p" {...{
            "href": "../../atoms/Button"
          }}>{`Button (Atom)`}</a></p>
      </li>
    </ol>
    <h2>{`Code`}</h2>
    <h3>{`Dokumentation`}</h3>
    <p>{`Das folgende Storybook zeigt ArtefactIntro in einer Live Demo. Des Weiteren kann in dieser Testumgebung ArtefactIntro mit verschiedenen Props, Werten und Variante getestet werden.`}</p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="React Dokumentation" actionIcon="launch" aspectRatio="2:1" href="https://storybook-cranachdesign.netlify.app/?path=/story/organism-artefactintro--template" mdxType="ResourceCard">
  </ResourceCard>
      </Column>
    </Row>
    <h3>{`Code`}</h3>
    <p>{`ArtefactIntro mit Standardwerten`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javaScript",
        "metastring": "path=CodeSandbox src=https://gatsby-theme-carbon.now.sh",
        "path": "CodeSandbox",
        "src": "https://gatsby-theme-carbon.now.sh"
      }}>{`
<ArtefactIntro />

`}</code></pre>
    <p>{`Beispiel: ArtefactIntro mit der Übergabe aller möglichen props`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javaScript",
        "metastring": "path=CodeSandbox src=https://gatsby-theme-carbon.now.sh",
        "path": "CodeSandbox",
        "src": "https://gatsby-theme-carbon.now.sh"
      }}>{`
<ArtefactIntro
  logoTitle={'cranach digital archive_'}
  artefactCardTitle={'Doppelbildnis Friedrich der Weise'}
  artefactCardSubtitle={'Lucas Cranach der Ältere'}
  artefactCardDate={'1510'}
  artefactCardImgSrc={'https://lucascranach.org/application/files/5715/2205/3270/Martin-Luther-als-Junker-Joerg.jpg'}
  artefactCardImgAlt={'cranach image'}
  artefactCardClassification={'Druckgrafik'}
  paragraphText={'Lucas Cranach der Ältere war einer der bedeutendsten deutschen Maler, Grafiker und Buchdrucker der Renaissance.'}
  buttonSize={'large'}
  buttonLabel={'Jetzt zur Webseite'}
/>

`}</code></pre>
    <h4>{`Props`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Optionen`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`logoTitle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`cda_`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Beschriftung des Logos`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`artefactCardTitle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Doppelbildnis Friedrich der Weise`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Haupttitel von des digitalen Kunstwerks`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`artefactCardSubtitle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Lucas Cranach der Ältere`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Subtitel von des digitalen Kunstwerks`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`artefactCardDate`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1510`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Datum von des digitalen Kunstwerks`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`artefactCardImgSrc`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://lucascranach.org/application/files/1715/2120/9916/Portraet001.jpg"
            }}>{`https://lucascranach.org/application/files/1715/2120/9916/Portraet001.jpg`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Bild von des digitalen Kunstwerks`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`artefactCardImgAlt`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Cranach Image`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Alternativer Bildtext von des digitalen Kunstwerks`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`artefactCardClassification`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Lucas Cranach der Ältere`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Klassifikation von des digitalen Kunstwerks`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`paragraphText`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`type your text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Detaillierter Text zur Erläuterung des Intros`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`buttonSize`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`medium`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`small`}</inlineCode>{`, `}<inlineCode parentName="td">{`medium`}</inlineCode>{`, `}<inlineCode parentName="td">{`large`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Festlegung der Größe, Standard`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`buttonLabel`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`type your label`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Beschriftung des Buttons`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Feedback`}</h2>
    <p>{`Helfe uns um diese Komponente/Pattern zu verbessern, indem sie Feedback geben, fragen stelle oder andere Kommentare auf `}<a parentName="p" {...{
        "href": "https://github.com/cranach-design-system/cranach-design/issues/new?assignees=&labels=&template=website-feedback.md&title=Website+feedback"
      }}>{`Github`}</a>{` hinterlassen.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      